import axios from 'axios'
import HTTP from './http'

export default {
    updateCommissionPercents: payload => axios.put(HTTP.UPDATE_PERCENTS, { params: { ...payload } }),
    getAgentCommissions: payload => axios.get(HTTP.AGENT_CLIENT_COMMISSIONS, { params: { ...payload } }),
    updateCommission: payload => axios.put(HTTP.AGENT_CLIENT_COMMISSIONS, { ...payload }),
    createNewCommission: payload => axios.post(HTTP.AGENT_CLIENT_COMMISSIONS, { params: { ...payload } }),
    deleteCommission: payload => axios.delete(HTTP.AGENT_CLIENT_COMMISSIONS, { params: { ...payload } }),
    getAgentCommissionTotals: payload => axios.get(HTTP.AGENT_COMMISSION_TOTALS, { params: { ...payload } }),
    getSubAgentCommissions: payload => axios.get(HTTP.SUB_AGENT_COMMISSION, { params: { ...payload } }),
    updateAgents: payload => axios.post(HTTP.UPDATE_AGENTS, { ...payload }),

    createMentorCommission: payload => axios.post(HTTP.CREATE_MENTOR_COMMISSION, { ...payload }),
    deleteMentorCommission: payload => axios.delete(HTTP.DELETE_MENTOR_COMMISSION, { params: { ...payload } }),
    editMentorCommission: payload => axios.patch(HTTP.EDIT_MENTOR_COMMISSION, payload),
    getMentorCommissionsByAgentClient: payload =>
        axios.get(HTTP.MENTOR_COMMISSIONS_BY_AGENT_CLIENT, { params: { ...payload } }),
    getMentorCommissionsByMonth: payload => axios.get(HTTP.MENTOR_COMMISSIONS_BY_MONTH, { params: { ...payload } }),
    approveMentorCommissions: payload => axios.get(HTTP.APPROVE_MENTOR_COMMISSIONS, { params: { ...payload } }),
    exportMentorCommissions: payload =>
        axios.get(HTTP.EXPORT_MENTOR_COMMISSIONS, { params: { ...payload }, responseType: 'blob' }),
    getMentorCommissionReports: payload => axios.get(HTTP.MENTOR_COMMISSION_REPORTS, { params: payload }),
    mentorCommissionReportFile: payload => axios.get(HTTP.MENTOR_COMMISSION_REPORT_FILE, { params: { ...payload } }),
    commissionsDB: payload => axios.get(HTTP.COMMISSIONS_FROM_DB, { params: payload }),
    commissionsCurrentMonth: payload => axios.get(HTTP.COMMISSIONS_CURRENT_MONTH, { params: payload }),
    deleteCommissionRow: payload => axios.delete(HTTP.COMMISSIONS_FROM_DB, { params: payload }),
    editCommissionRow: payload => axios.patch(HTTP.COMMISSIONS_FROM_DB, { params: payload }),
    findUserForCommission: payload => axios.get(HTTP.FIND_USER_COMMISSION, { params: payload }),
    getProductsForEditCommission: payload => axios.get(HTTP.GET_PRODUCTS, { params: payload }),
    getAdminClientsFile: payload => axios.get(HTTP.GET_FILE, { params: payload, responseType: 'blob' }),
    enqueueClientsFile: payload => axios.post(HTTP.ENQUEUE_FILE, payload),
    createCommissionRow: payload => axios.post(HTTP.CREATE_COMMISSION_ROW, { params: payload }),
}
